import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiProgressBar } from 'noddi-ui-web';
import {
  CustomDateFormats,
  getReservationRemainingFraction,
  noddiFormatDate,
  stringToUpperCase,
  useReservationCountdown
} from 'noddi-util';

type Props = {
  reservation: { startsAt: string; endsAt: string; reservedFrom?: string; reservedUntil: string };
};

/** The held time and its draining countdown — logging in costs the customer time they can see. */
export const ReservedTimeNotice = ({ reservation }: Props) => {
  const countdownDisplay = useReservationCountdown(reservation.reservedUntil);
  const remainingFraction = getReservationRemainingFraction(reservation.reservedFrom, reservation.reservedUntil);
  const timeWindowDisplay = stringToUpperCase(
    `${noddiFormatDate(new Date(reservation.startsAt), CustomDateFormats.FULL_WEEKDAY_DAY_DOT_MONTH)}, ${noddiFormatDate(
      new Date(reservation.startsAt),
      CustomDateFormats.TIME
    )}–${noddiFormatDate(new Date(reservation.endsAt), CustomDateFormats.TIME)}`
  );

  return (
    <NoddiBasicCard className='flex flex-col gap-2'>
      <div className='flex items-center gap-2'>
        <NoddiIcon name='Calendar' className='shrink-0' />
        <span className='font-semibold'>{timeWindowDisplay}</span>
      </div>
      {countdownDisplay && (
        <div className='flex items-center gap-2'>
          {remainingFraction !== null && (
            <NoddiProgressBar
              value={remainingFraction * 100}
              wrapperClassName='min-w-0 border-0 bg-border'
              className='h-1 bg-secondary'
            />
          )}
          <span className='text-sm whitespace-nowrap text-muted-foreground'>
            <Trans>Reserved for</Trans> {countdownDisplay}
          </span>
        </div>
      )}
    </NoddiBasicCard>
  );
};
